const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_authenticated-user/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklæringId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated-user/oppdrag/$tluxCaseId/hjemmelserklæring/$hjemmelserklæringId/")({
  loader: async ({
    params
  }) => {
    const {
      tluxCaseId,
      hjemmelserklæringId
    } = params;
    const res = await routeLoaderApiClient.oppdrag[":tluxCaseId"].hjemmelserklæring[":hjemmelserklæringId"].$get({
      param: {
        tluxCaseId,
        hjemmelserklæringId
      }
    });
    if (res.ok === false) {
      throw new Error("Failed to fetch sletting");
    }
    return {
      response: await res.json()
    };
  },
  head: () => ({
    meta: [{
      title: "Rediger hjemmelserklæring | Alice & Bob"
    }]
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});